(ns renolit-roofing-service.view.service.service-information
  (:require [renolit-roofing-service.layout.components :refer [entity-section]]
            [renolit-roofing-service.layout.form :as layout.form]
            [renolit-roofing-service.layout.form.form-item.date-picker]
            [renolit-roofing-service.localization :refer [t]]
            [renolit-roofing-service.shared.domain.types :as dom.types]))

(def ^:const view-context
  :add-service-view)

(defn choice-display-fn
  [{:keys [label-transl-kw]}]
  (t [label-transl-kw]))

(defn- service-basic-data
  [state]
  [:div.service-section.service-section--half
   [layout.form/item
    {:context view-context
     :type :input
     :state state
     :path [:name]
     :schema [:string]
     :label-transl-kw :domain.service/name
     :placeholder-transl-kw :page.service.placeholder/name
     :mandatory? true}]
   [layout.form/item
    {:context :context
     :type :advanced-select-with-fixed-choices
     :search? false
     :multi? false
     :mandatory? true
     :state state
     :path [:origin]
     :attribute-path [:options :origin]
     :schema [:keyword]
     :choices (dom.types/get-dropdown-values :service-origin)
     :choice-display-fn choice-display-fn
     :label-transl-kw :domain.service/origin
     :placeholder-transl-kw :form.advanced-select/select}]
   (comment
     [layout.form/item
      {:context :context
       :type :advanced-select-with-entity-list
       :search? false
       :multi? false
       :mandatory? true
       :state state
       :path [:reason]
       :attribute-path [:options :reason]
       :choice-id-kw :id
       :choice-display-name-kw :name
       :schema [:uuid]
       :entity-list-opts {}
       :label-transl-kw :domain.service/reason
       :placeholder-transl-kw :form.advanced-select/select}])
   [layout.form/item
    {:context view-context
     :type :advanced-select-with-fixed-choices
     :search? false
     :multi? false
     :mandatory? true
     :state state
     :path [:reason]
     :schema [:keyword]
     :choices (dom.types/get-dropdown-values :service-reason)
     :choice-display-fn choice-display-fn
     :label-transl-kw :domain.service/reason
     :placeholder-transl-kw :form.advanced-select/select}]
   [layout.form/item
    {:context view-context
     :type :text-area
     :input-opts {:rows 2}
     :state state
     :path [:reason-text]
     :schema [:string]
     :label-transl-kw :domain.service/reason-text
     :placeholder-transl-kw :page.service.placeholder/reason-text
     :mandatory? true}]
   [layout.form/item
    {:context view-context
     :type :input
     :state state
     :path [:objective]
     :schema [:string]
     :label-transl-kw :domain.service/objective
     :placeholder-transl-kw :page.service.placeholder/objective
     :mandatory? true}]
   [layout.form/item
    {:context view-context
     :type :input
     :state state
     :path [:manager]
     :label-transl-kw :domain.service/manager
     :placeholder-transl-kw :page.service.placeholder/manager
     :mandatory? true}]
   [layout.form/item
    {:context view-context
     :type :input
     :state state
     :path [:authorized-diagnostic-contractor]
     :label-transl-kw :domain.service/contractor
     :placeholder-transl-kw :page.service.placeholder/contractor
     :mandatory? true}]
   [layout.form/item
    {:context view-context
     :type :input
     :state state
     :path [:inspector]
     :label-transl-kw :domain.service/inspector
     :placeholder-transl-kw :page.service.placeholder/inspector
     :mandatory? true}]
   [layout.form/item
    {:context view-context
     :type :date-picker
     :date-type :instant
     :state state
     :path [:last-diagnosis-date]
     :label-transl-kw :domain.service/last-diagnosis-date
     :placeholder-transl-kw :page.service.placeholder/last-diagnosis-date
     :mandatory? true
     :max-date :today}]
   [layout.form/item
    {:context view-context
     :type :date-picker
     :date-type :instant
     :state state
     :path [:last-maintenance-date]
     :label-transl-kw :domain.service/last-maintenance-date
     :placeholder-transl-kw :page.service.placeholder/last-maintenance-date
     :mandatory? true
     :max-date :today}]])

(defn- client-information
  [state]
  [:div.service-section.service-section--half
   [layout.form/item
    {:context view-context
     :type :input
     :state state
     :path [:customer-name]
     :label-transl-kw :domain.client/name
     :placeholder-transl-kw :page.client.placeholder/name
     :mandatory? true}]
   [layout.form/item
    {:context :context
     :type :advanced-select-with-fixed-choices
     :search? false
     :multi? false
     :mandatory? true
     :state state
     :path [:customer-profile]
     :attribute-path [:options :customer-profile]
     :schema [:keyword]
     :choices (dom.types/get-dropdown-values :customer-profile)
     :choice-display-fn choice-display-fn
     :label-transl-kw :domain.client/profile
     :placeholder-transl-kw :form.advanced-select/select}]
   [layout.form/item
    {:context view-context
     :type :input
     :state state
     :path [:company-owner]
     :label-transl-kw :domain.client/company-owner
     :placeholder-transl-kw :page.client.placeholder/company-owner
     :mandatory? true}]
   [layout.form/item
    {:context view-context
     :type :input
     :state state
     :path [:company-industry]
     :label-transl-kw :domain.client/company-industry
     :placeholder-transl-kw :page.client.placeholder/company-industry
     :mandatory? true}]])

(defn- building-information
  [state]
  [:div.service-section.service-section--half
   [layout.form/item
    {:context view-context
     :type :input
     :state state
     :path [:building-height]
     :schema [:double]
     :label-transl-kw :domain.building/height
     :placeholder-transl-kw :page.building.placeholder/height
     :mandatory? true}]
   [layout.form/item
    {:context view-context
     :type :input
     :state state
     :path [:roof-slope]
     :label-transl-kw :domain.building/inclination
     :placeholder-transl-kw :page.building.placeholder/inclination
     :mandatory? true}]
   [layout.form/item
    {:context view-context
     :type :input
     :state state
     :path [:upstand]
     :schema [:double]
     :label-transl-kw :domain.building/upstand
     :placeholder-transl-kw :page.building.placeholder/upstand
     :mandatory? true}]
   [layout.form/item
    {:context view-context
     :type :input
     :state state
     :path [:service-area]
     :schema [:double]
     :label-transl-kw :domain.building/surface
     :placeholder-transl-kw :page.building.placeholder/surface
     :mandatory? true}]])

(defn- roof-structure
  [state]
  [:div.service-section.service-section--full
   (comment
     [layout.form/item
      {:context :context
       :type :advanced-select-with-entity-list
       :search? false
       :multi? false
       :mandatory? true
       :state state
       :path [:roofing-membrane]
       :attribute-path [:options :roofing-membrane]
       :choice-id-kw :id
       :choice-display-name-kw :name
       :schema [:uuid]
       :entity-list-opts {}
       :label-transl-kw :domain.roof/membrane
       :placeholder-transl-kw :form.advanced-select/select}])
   [layout.form/item
    {:context view-context
     :type :input
     :state state
     :path [:roofing-membrane]
     :schema [:string]
     :label-transl-kw :domain.roof/membrane
     :placeholder-transl-kw :form.advanced-select/select
     :mandatory? true}]
   (comment
     [layout.form/item
      {:context :context
       :type :advanced-select-with-entity-list
       :search? false
       :multi? false
       :mandatory? true
       :state state
       :path [:application-method-id]
       :attribute-path [:options :application-method]
       :choice-id-kw :id
       :choice-display-name-kw :name
       :schema [:uuid]
       :entity-list-opts {}
       :label-transl-kw :domain.roof/application-method
       :placeholder-transl-kw :form.advanced-select/select}])
   [layout.form/item
    {:context view-context
     :type :input
     :state state
     :path [:application-method]
     :schema [:string]
     :label-transl-kw :domain.roof/application-method
     :placeholder-transl-kw :form.advanced-select/select
     :mandatory? true}]
   (comment
     [layout.form/item
      {:context :context
       :type :advanced-select-with-entity-list
       :search? false
       :multi? false
       :mandatory? true
       :state state
       :path [:support-id]
       :attribute-path [:options :support]
       :choice-id-kw :id
       :choice-display-name-kw :name
       :schema [:uuid]
       :entity-list-opts {}
       :label-transl-kw :domain.roof/support
       :placeholder-transl-kw :form.advanced-select/select}])
   [layout.form/item
    {:context view-context
     :type :input
     :state state
     :path [:support]
     :schema [:string]
     :label-transl-kw :domain.roof/support
     :placeholder-transl-kw :form.advanced-select/select
     :mandatory? true}]
   (comment
     [layout.form/item
      {:context :context
       :type :advanced-select-with-entity-list
       :search? false
       :multi? false
       :mandatory? true
       :state state
       :path [:protective-glue]
       :attribute-path [:options :protective-glue]
       :choice-id-kw :id
       :choice-display-name-kw :name
       :schema [:uuid]
       :entity-list-opts {}
       :label-transl-kw :domain.roof/protective-glue
       :placeholder-transl-kw :form.advanced-select/select}])
   [layout.form/item
    {:context view-context
     :type :input
     :state state
     :path [:protective-glue]
     :schema [:string]
     :label-transl-kw :domain.roof/protective-glue
     :placeholder-transl-kw :form.advanced-select/select
     :mandatory? true}]
   (comment
     [layout.form/item
      {:context :context
       :type :advanced-select-with-entity-list
       :search? false
       :multi? false
       :mandatory? true
       :state state
       :path [:vapor-barrier]
       :attribute-path [:options :vapor-barrier]
       :choice-id-kw :id
       :choice-display-name-kw :name
       :schema [:uuid]
       :entity-list-opts {}
       :label-transl-kw :domain.roof/vapor-barrier
       :placeholder-transl-kw :form.advanced-select/select}])
   [layout.form/item
    {:context view-context
     :type :input
     :state state
     :path [:vapor-barrier]
     :schema [:string]
     :label-transl-kw :domain.roof/vapor-barrier
     :placeholder-transl-kw :form.advanced-select/select
     :mandatory? true}]
   (comment
     [layout.form/item
      {:context :context
       :type :advanced-select-with-entity-list
       :search? false
       :multi? false
       :mandatory? true
       :state state
       :path [:glue-type]
       :attribute-path [:options :glue-type]
       :choice-id-kw :id
       :choice-display-name-kw :name
       :schema [:uuid]
       :entity-list-opts {}
       :label-transl-kw :domain.roof/glue-type
       :placeholder-transl-kw :form.advanced-select/select}])
   [layout.form/item
    {:context view-context
     :type :input
     :state state
     :path [:glue-type]
     :schema [:string]
     :label-transl-kw :domain.roof/glue-type
     :placeholder-transl-kw :form.advanced-select/select
     :mandatory? true}]
   (comment
     [layout.form/item
      {:context :context
       :type :advanced-select-with-entity-list
       :search? false
       :multi? false
       :mandatory? true
       :state state
       :path [:thermal-insulation]
       :attribute-path [:options :thermal-insulation]
       :choice-id-kw :id
       :choice-display-name-kw :name
       :schema [:uuid]
       :entity-list-opts {}
       :label-transl-kw :domain.roof/thermal-insulation
       :placeholder-transl-kw :form.advanced-select/select}])
   [layout.form/item
    {:context view-context
     :type :input
     :state state
     :path [:thermal-insulation]
     :schema [:string]
     :label-transl-kw :domain.roof/thermal-insulation
     :placeholder-transl-kw :form.advanced-select/select
     :mandatory? true}]
   (comment
     [layout.form/item
      {:context :context
       :type :advanced-select-with-entity-list
       :search? false
       :multi? false
       :mandatory? true
       :state state
       :path [:separation-layer]
       :attribute-path [:options :separation-layer]
       :choice-id-kw :id
       :choice-display-name-kw :name
       :schema [:uuid]
       :entity-list-opts {}
       :label-transl-kw :domain.roof/separation-layer
       :placeholder-transl-kw :form.advanced-select/select}])
   [layout.form/item
    {:context view-context
     :type :input
     :state state
     :path [:separation-layer]
     :schema [:string]
     :label-transl-kw :domain.roof/separation-layer
     :placeholder-transl-kw :form.advanced-select/select
     :mandatory? true}]
   (comment
     [layout.form/item
      {:context :context
       :type :advanced-select-with-entity-list
       :search? false
       :multi? false
       :mandatory? true
       :state state
       :path [:color]
       :attribute-path [:options :color]
       :choice-id-kw :id
       :choice-display-name-kw :name
       :schema [:uuid]
       :entity-list-opts {}
       :label-transl-kw :domain.roof/color
       :placeholder-transl-kw :form.advanced-select/select}])
   [layout.form/item
    {:context view-context
     :type :input
     :state state
     :path [:color]
     :schema [:string]
     :label-transl-kw :domain.roof/color
     :placeholder-transl-kw :form.advanced-select/select
     :mandatory? true
     :css-class-prefix "service-section__item--double"}]
   (comment
     [layout.form/item
      {:context :context
       :type :advanced-select-with-entity-list
       :search? false
       :multi? false
       :mandatory? true
       :state state
       :path [:fixation-id]
       :attribute-path [:options :fixation]
       :choice-id-kw :id
       :choice-display-name-kw :name
       :schema [:uuid]
       :entity-list-opts {}
       :label-transl-kw :domain.roof/fixation
       :placeholder-transl-kw :form.advanced-select/select
       :css-class-prefix "service-section__item--triple"}])
   [layout.form/item
    {:context view-context
     :type :input
     :state state
     :path [:fixation]
     :schema [:string]
     :label-transl-kw :domain.roof/fixation
     :placeholder-transl-kw :form.advanced-select/select
     :mandatory? true
     :css-class-prefix "service-section__item--double"}]])

(defn main
  [state]
  [:div.service-form
   [:<>
    [entity-section
     {:title-transl-kw :page.service.add.service-data}
     [service-basic-data state]]
    [:div.service-section.service-section--half
     [entity-section
      {:title-transl-kw :page.service.add.customer-data}
      [client-information state]]
     [entity-section
      {:title-transl-kw :page.service.add.building-information}
      [building-information state]]]
    [entity-section
     {:title-transl-kw :page.service.add.roof-structure}
     [roof-structure state]]]])
